/**
 * Diagnostic Header Component
 *
 * Simple branded header for diagnostic pages
 * Shows Daring Futures logo and branding
 */

import React from 'react';

function DiagnosticHeader() {
  return (
    <nav style={{
      width: '100%',
      backgroundColor: '#fff',
      borderBottom: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      marginBottom: '0'
    }}>
      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={process.env.PUBLIC_URL + '/df-web-logo.svg'}
            alt="Daring Futures - Realising Ambition"
            style={{ height: '48px' }}
          />
        </div>

        {/* Tagline (optional, can be hidden on mobile) */}
        <div style={{
          fontSize: '14px',
          color: '#697A90',
          display: 'none',
          '@media (min-width: 768px)': {
            display: 'block'
          }
        }}>
          Evidence-Based Transformation Diagnostics
        </div>
      </div>
    </nav>
  );
}

export default DiagnosticHeader;
